import { defineMessages } from 'react-intl-next';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closedOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closesOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-deal.deal-label',
		defaultMessage: 'Deal',
		description: 'Deal subtype label',
	},
	closedOn: {
		id: 'search-graph-deal.closed-on',
		defaultMessage: 'Closed on {date}',
		description: 'Date when the deal was closed',
	},
	closesOn: {
		id: 'search-graph-deal.closes-on',
		defaultMessage: 'Closes on {date}',
		description: 'Future date when the deal is expected to close',
	},
});
